<template>
  <div class="catalog-repetitor">
    <section>
      <repetitor-modal
        v-if="consultModal || freeModal"
        :card="freeModalCard"
        :consult="consultModal"
        @close="closeModal"
      />

      <repetitor-banner
        @open-consult-modal="consultModal = true"
      />
    </section>

    <repetitor-catalog
      @open-free-modal="openFreeModal"
      @subject="subjectFilter = $event"
      @grade="gradeFilter = $event"
      @target="targetFilter = $event"
    />

    <faq-accordion-new
      page="repetitor"
      sticker-url="/v2/catalog/repetitor/star.png"
    />

    <exam-form />

    <repetitor-seo />
  </div>
</template>

<script>
import HeadMixin from '~/mixins/HeadMixin';
import FaqAccordionNew from '~/components/v2/common/FaqAccordion/FaqAccordionNew.vue';
import ExamForm from '~/components/v2/ege/ExamForm.vue';
import RepetitorSeo from '~/components/v2/catalog/repetitor/RepetitorSeo.vue';
import RepetitorBanner from '../../../components/v2/catalog/repetitor/RepetitorBanner.vue';
import RepetitorModal from '../../../components/v2/catalog/repetitor/RepetitorModal.vue';
import RepetitorCatalog from '../../../components/v2/catalog/repetitor/catalog/RepetitorCatalog.vue';
import { gradeList, subjectList, targetList } from '../../../components/v2/catalog/repetitor/catalog/repetitorCards';

export default {
  name: 'CatalogRepetitorPage',
  components: {
    RepetitorCatalog,
    RepetitorModal,
    RepetitorBanner,
    RepetitorSeo,
    ExamForm,
    FaqAccordionNew,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,

  data: () => ({
    consultModal: false,
    freeModal: false,
    freeModalCard: null,

    subjectFilter: null,
    gradeFilter: null,
    targetFilter: null,

    // для head
    image: '/v2/catalog/repetitor/share-image.jpg',
  }),

  computed: {
    // для head
    headByFilter() {
      let title = 'Репетиторы';
      if (this.subjectFilter) {
        title += ` по ${subjectList.find(({ id }) => id === this.subjectFilter).forTitle}`.toLowerCase();
      }
      if (this.gradeFilter) {
        title += ` ${gradeList.find(({ id }) => id === this.gradeFilter).title}`;
      }
      if (this.targetFilter) {
        title += ` ${targetList.find(({ id }) => id === this.targetFilter).title}`.toLowerCase();
      }

      return title;
    },
    title() {
      if (!this.subjectFilter && !this.gradeFilter && !this.targetFilter) {
        return 'Занимайтесь с репетиторами онлайн-школы «Синергия»';
      }

      return `${this.headByFilter} онлайн. Начните подготовку!`;
    },
    /* eslint-disable max-len,vue/max-len */
    description() {
      if (!this.subjectFilter && this.gradeFilter && this.targetFilter) {
        return `${this.headByFilter} онлайн по любому предмету`;
      }

      if (this.subjectFilter && !this.gradeFilter && this.targetFilter) {
        return `${this.headByFilter} онлайн`;
      }

      if (this.subjectFilter && !this.targetFilter) {
        return `${this.headByFilter} онлайн под любые цели: подтянуть знания, сделать дз, подготовиться к ЕГЭ или ОГЭ, к олимпиаде, экзамену или впр`;
      }

      if (!this.subjectFilter && this.gradeFilter && !this.targetFilter) {
        return `${this.headByFilter} онлайн по любым предметам и целям: подтянуть знания, сделать дз, подготовиться к ЕГЭ или ОГЭ, к олимпиаде, экзамену или впр`;
      }

      if (!this.subjectFilter && !this.gradeFilter && this.targetFilter) {
        return `${this.headByFilter} онлайн по любым предметам`;
      }

      return 'Репетиторы с 1 по 11 класс под любые цели: подтянуть знания, сделать дз, подготовиться к ЕГЭ или ОГЭ, к олимпиаде, экзамену или впр';
    },
    /* eslint-enable */
  },

  mounted() {
    // чтобы работал sticky
    document.querySelector('.v2-layout').style.overflow = 'inherit';
  },
  methods: {
    closeModal() {
      this.consultModal = false;
      this.freeModal = false;
    },
    openFreeModal(card) {
      this.freeModal = true;
      this.freeModalCard = card;
    },
  },
};
</script>

<style scoped lang="scss">

.catalog-repetitor {
  background-color: $gray-bg;

  padding-top: 80px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 200px;

  @include media-down(laptop) {
    gap: 150px;
  }

  @include media-down(tablet) {
    gap: 120px;
  }

  @include media-down(mobile) {
    gap: 96px;
  }

  :deep(.repetitor-catalog) {
    @include media-up(laptop) {
      margin-top: -80px;
    }
  }

  :deep(.repetitor__filters-mob) {
    margin-top: -12px;
  }

  ::v-deep .faq {
    overflow: hidden;

    &__sticker {
      z-index: 2;
      top: 120px;
      right: -25px;

      @include media-down(tablet) {
        width: 40px;
        top: 125px;
        right: -3px;
      }
    }
  }
}

</style>
